import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ValidationOutcomeScreen from './screens/ValidationOutcomeScreen/ValidationOutcomeScreen';
import Home from './screens/home';
import LoginQrCodeScreen from './screens/loginQrCode/LoginQrCodeScreen';
import LoginScreen from './screens/login/LoginScreen';
import IssuanceScreen from './screens/issuance/IssuanceScreen';
import IssuanceFormScreen from './screens/issuanceForm/IssuanceFormScreen';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/validation-process/:status"
          element={<ValidationOutcomeScreen />}
        />
        <Route
          path="/login"
          element={<LoginScreen />}
        />
        <Route
          path="/login/qrCode"
          element={<LoginQrCodeScreen />}
        />
        <Route
          path="/issuance"
          element={<IssuanceScreen />}
        />
        <Route
          path="/issuance/form"
          element={<IssuanceFormScreen />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
